import { Constants } from '../Constants';

export interface EntityVisibilityRule {
  current?: string | null;
  showFor?: string[];
  hideFor?: string[];
}

interface EntityDefinition {
  resolveCurrent?: () => string;
}

export type ConditionalEntityKey = 'client' | 'lob';

const getCurrentClientFromStorage = () => {
  if (typeof window === 'undefined') {
    return '';
  }

  try {
    return (
      sessionStorage.getItem(Constants.STORAGE_KEYS.SESSION.CLIENT_NAME) || ''
    );
  } catch {
    return '';
  }
};

// Add new entities here as business requirements evolve.
// Usage example:
// 1) Add a new key in ConditionalEntityKey, e.g. 'coverageType'.
// 2) Add resolver only when current value can be derived internally.
// export type ConditionalEntityKey = 'client' | 'lob' | 'coverageType';
// export const ENTITY_DEFINITIONS = {
//   client: { resolveCurrent: getCurrentClientFromStorage },
//   lob: {},
//   coverageType: {
//     resolveCurrent: () =>
//       sessionStorage.getItem(Constants.STORAGE_KEYS.SESSION.COVERAGE_TYPE) || '',
//   },
// };
export const ENTITY_DEFINITIONS: Record<
  ConditionalEntityKey,
  EntityDefinition
> = {
  client: {
    resolveCurrent: getCurrentClientFromStorage,
  },
  lob: {},
};
